
// import './App.css';

function App() {
  return (
    <main style={{maxWidth: '600px', padding: '1rem'}}>
      <h1>Flow State Software LLC</h1>
      <p>
        Flow State Software LLC is a producer and operator of web-based applications.
      </p>
      <h2>apps</h2>
      <h3><a href="https://www.liste.co" target="_blank" rel="noreferrer">Liste.co</a></h3>
      <p>
        Flow State Software's premier web-app dedicated to small merchants who want to cut through the noise and start selling online.<br />
        No marketplace silohs and no high-maintenace webpages. A flat low monthly fee to just Liste!
      </p>
      <h2>contact</h2>
      <p>
        All inquires can be directed to <a href="mailto:jacobwintr@gmail.com">jacobwintr@gmail.com</a>.
      </p>
      <h2>policies</h2>
      <p>Policies that appear on this page are to be superceded by the policies established by Flow State Software's individual services</p>
      <h3>refund and dispute policy</h3>
      <p>
        Flow State Software LLC merely creates software that enables current financial service technologies to fulfill specific services. All disputes are set to be managed by Flow State Softwares payment gateway provider <a href="stripe.com">Stripe</a>.
        Refunds can be requested by contacting us at <a href="mailto:jacobwintr@gmail.com">jacobwintr@gmail.com</a>, but refunds are not guaranteed.
      </p>
    </main>
  );
}

export default App;
